import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage';

const getValue = (merchantId, branchId, key, moduleId) => {
	return Client.get(`${baseUrl}/branch-setting/${merchantId}/${branchId}`, {
		key,
		moduleId,
	});
};

const getValues = (merchantId, branchId, moduleId) => {
	return Client.get(
		`${baseUrl}/branch-setting/${merchantId}/${branchId}/list/${moduleId}`
	);
};

const setValue = (merchantId, branchId, payload) => {
	return Client.post(
		`${baseUrl}/branch-setting/${merchantId}/${branchId}`,
		payload
	);
};

export default {
	getValue,
	getValues,
	setValue,
};
